/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
 function initSliders() {
 $('[data-slider-1]').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    imagesLoaded: true,
    adaptiveHeight: false,
    groupCells: true,
    imagesLoaded: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 50,
      x3: 20
    }
  });
  $('[data-slider-2]').each(function(){
    var slides = $(this).find('.plug-featured-product__slide');
    var slides_clone = slides.clone();
    if (slides.length <= 4) {
      $(this).append(slides_clone);
    }
  })
  $('[data-slider-2]').flickity({
    // options
    contain: true,
    cellAlign: 'left',
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    freeScroll: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 50,
      x3: 20
    }
  });
  $('.Product__Slideshow').flickity();
  $('.Product__SlideshowNavImage').click(function(){
    console.log("CHANGING SLIDE")
    $(this).siblings().removeClass('is-selected');
    $(this).addClass('is-selected');
    var image_id = $(this).attr('image_id');
    var target_slide = $('.Product__Slideshow').find(`[data-image-id="${image_id}"]`);
    var slide_position = target_slide.attr('data-image-position');
    $('.Product__Slideshow').flickity('select', slide_position);
  });
  
}
initSliders();
$('.plug-image-description__button-trigger').click(function(){
  var target;
  if ($(this).hasClass('description-top')) {
    target = $('.plug-image-description__description-top p')
  } else {
    target = $('.plug-image-description__description-bottom p')
  }
  if ($(target).hasClass('expand')) {
    $(this).find('.default-icon').css('display', 'flex');
    $(this).find('.Icon--x').hide();
  } else {
    console.log($(this).find('.default-icon'))
    $(this).find('.default-icon').css('display', 'none');
    $(this).find('.Icon--x').show();
  }
  target.toggleClass('expand');
});
$('.product-features__tab').click(function(){
  var target = $(this).attr('target');
  $('.product-features__tab').removeClass('active');
  $(this).addClass('active');
  $(`.product-features__tab-content`).removeClass('active');
  $(`.product-features__tab-content[key="${target}"]`).addClass('active');
});
$(document).on('click', '.subscription_info, .subscription-product__popup-close, .subscription-product__overlay', function(){
  $('.subscription-product__popup').toggleClass('active');
  $('.subscription-product__overlay').toggleClass('active');
});
$(document).on('click', '.plug-collection-faq__question', function(){
  var $parent = $(this).parents('.plug-collection-faq__question-container');
  $parent.find('svg').toggleClass('hide');
  $parent.find('.plug-collection-faq__answer').toggleClass('hide');
});
function initUpsell() {
  console.log("INIT UPSELL");
  var collection = $('.cart-drawer__upsell').attr('collection');
  var product_count = $('.cart-drawer__upsell').attr('product_count');
  var limit = parseInt($('.cart-drawer__upsell').attr('limit'));
  var loop_count = Math.ceil(product_count / 20);
  var allproducts = []
  var collectionPageXhrs = [];
  for (let page = 0; page < loop_count; page++) {
    allproducts.push([])
    var page_url = page + 1;
    var collectionAjax = jQuery.ajax({
      url: '/collections/' + collection + "?page=" + page_url + "&view=upsell-ajax",
      cache: false,
      success: function(response) {
        let filterProducts = JSON.parse(response);
        console.log(filterProducts)
        filterProducts = filterProducts.products;
        for (let i = 0; i < filterProducts.length; i++) {
          allproducts[page].push(filterProducts[i].handle);
        }   
      }
    });
    collectionPageXhrs.push(collectionAjax);
  }
  $.when.apply($, collectionPageXhrs).done(function() {
    var singlearray = [];
    var current_items = [];
    $('.CartItemWrapper').each(function(){
      current_items.push($(this).attr('handle'));
    });
    for (let i = 0; i < allproducts.length; i++) {
      for (let j = 0; j < allproducts[i].length; j++) {
        var match = false;
        for (let k = 0; k < current_items.length; k++) {
          if (current_items[k] == allproducts[i][j]) {
            match = true;
          }
        }
        if (!match) {
          singlearray.push(allproducts[i][j])
        }
      }
    }
    console.log(singlearray);
    shuffleArray(singlearray);
    var productPageXhrs = [];
    var productContent = [];
    for (let i = 0; i < limit; i++ ) {
      if (singlearray[i] != undefined) {
        productContent.push([]);
        var handle = singlearray[i]
        var productAjax = jQuery.ajax({
          url: '/products/' + handle + '?view=drawer-upsell',
          cache: false,
          success: function(response) {
            // console.log(response)
            // console.log(productContent);
            productContent[i].push(response);
          }
        });
        productPageXhrs.push(productAjax);
      }
    }
    $.when.apply($, productPageXhrs).done(function() {
      $('.cart-drawer__upsell-products').empty();
      for (let i = 0; i < productContent.length; i++ ) {
        $('.cart-drawer__upsell-products').append(productContent[i]);
      }
    });
  });
}

if ($('.cart-drawer__upsell').length > 0 && $('.CartItemWrapper').length > 0) {
  initUpsell();
}
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}

function initUGC() {
  var check_UGC = setInterval(function(){
    if ($('.stamped-review-card').length > 0) {
      $('.stamped-review-card').each(function(){
        var ugc_image_container = $(this).find('.stamped-reviews-photo').first().parent().clone().empty();
        var ugc_image_link = $(this).find('.stamped-reviews-photo').first().attr('src');
        if (ugc_image_link == undefined || ugc_image_link == '') {
          ugc_image_link = $(this).find('.stamped-reviews-photo').first().attr('data-src');
        }
        var ugc_image = $(`<img src="${ugc_image_link}" class="Image--lazyLoad">`);
        var ugc_image_height = $(ugc_image).height();
        var ugc_author = $(this).find('.stamped-reviews-author').text();
        var container = $('<div class="plug-ugc__content-container"></div>');
        var author = $('<div class="plug-ugc__content-author subtitle-3 font--normal color--2"></div>');
        var image = $('<div class="plug-ugc__content-image"></div>');
        author.text('@' + ugc_author);
        image.append(ugc_image);
        image.append(ugc_image_container);
        container.append(image);
        container.append(author);
        console.log($(ugc_image_height));
        $('.plug-UGC__slider').append(container);
      });
      var check_sliderheight = setInterval(function(){
        console.log("checking height: " + $('.plug-ugc__content-image').height())
        if ($('.plug-ugc__content-image').height() > 0) {
    
            var plug_ugc = $('[plug-ugc]').flickity({
              // options
              cellAlign: 'left',
              pageDots: false,
              prevNextButtons: true,
              wrapAround: true,
              imagesLoaded: true,
              arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 50,
                x3: 20
              }
            });
            $('.plug-UGC__container').removeClass('visually-hidden');
              var refresh_counter = 0;
  

          clearInterval(check_sliderheight);
        }
      }, 100)

      $('#stamped-reviews-widget').hide();
      clearInterval(check_UGC)
    }
  }, 100)

}

if ($(".plug-UGC__container").length > 0) {
  initUGC();
}
if ($('.template-index').length > 0) {
  var header_height = $('#section-header').height();
  $(document).scroll(function(){
    // console.log($(document)[0].scrollTop)
    // console.log($('html')[0].scrollTop + " : " + header_height)
    // console.log($('body')[0].scrollTop)
    if ($('html')[0].scrollTop > header_height) {
      console.log("Over")
      $('#section-header').addClass("header_background");
    } else {
      $('#section-header').removeClass("header_background");
    }
  })
}

// template-index
$('.plug-home-page-hero__learnmore').click(function(){
  var get_sections = $('.shopify-section');
  var parent_section = $(this).parents('.shopify-section')[0];
  var index = 0;
  var header_height = $('#section-header').height();;
  for (let i = 0; i < get_sections.length; i++) {
    if (parent_section == get_sections[i]){
      index = i;
    }
  }
  var offset_top = $(get_sections[index + 1]).position().top - header_height;
  $('html, body').animate({
    scrollTop: offset_top
  }, 800)
});

var about_title_width = $('.plug-about-us__about .plug-about-us__text-content h1').width();
$('.plug-about-us__about .plug-about-us__text-content .text-wrapper p').css('width', about_title_width);

if ($('.Cart__ItemList').length > 0 && $(window).width() < 749) {
  $('.cart-drawer__content').css('padding-top', `${$('.CartItemWrapper').first().height()}px`) 
}
